import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "../HomePage";

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route index element={<Homepage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
